import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List } from 'immutable'
import _parseInt from 'lodash/parseInt'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { scrollToTop } from '../../services/dom/index'
import { getPrimary } from '../../services/languages/index'
import { USER_STATUS_BLOCKED } from '../../services/user/index'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../Page/connect'
import { connect as connectStaticText } from '../StaticText/connect'
import { getEmailCustomerServiceUrl } from '../../services/url/index'
import { URL_ACCOUNT, URL_AI_CHAT, URL_HOME } from '../../services/url/constants'
import { PLAN_CATEGORY_AI_ONLY } from '../../services/plans/index'
import { isEntitled } from '../../services/subscription/index'
import Sherpa, { TYPE_SMALL_BLUE } from '../Sherpa/index'
import Button, { TYPES, SIZES } from '../Button/index'
import Link, { TARGET_BLANK } from '../Link/index'
import { H1, HEADING_TYPES } from '../Heading/index'
import ArrowRightIcon from '../Icon/icons/ArrowRight/index'

function CartAccessDeniedPage (props) {
  const {
    auth,
    user,
    staticText,
    userAccount,
  } = props
  const authToken = auth.get('jwt')
  const uid = user.getIn(['data', 'uid'])
  const accountOwnerUid = user.getIn(['data', 'account_owner_uid'])
  const isAccountOwner = _parseInt(uid) === _parseInt(accountOwnerUid)
  const userIsEntitled = isEntitled(auth.get('subscriptions', List()))
  const userProcessing = user.get('processing')
  const authProcessing = auth.get('processing')
  const userAccountBillingProcessing = userAccount.get('billingSubscriptionsProcessing')
  const userStatus = user.getIn(['data', 'status'])
  const userStatusBlocked = userStatus === USER_STATUS_BLOCKED
  const userPlanCategory = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'plan', 'planCategory'])
  const isAiOnly = userPlanCategory === PLAN_CATEGORY_AI_ONLY
  const userLanguage = getPrimary(user)
  const emailCustomerServiceUrl = getEmailCustomerServiceUrl(userLanguage)

  useEffect(() => {
    scrollToTop()
  }, [userProcessing, authProcessing])

  const getText = () => {
    if (!userIsEntitled && !isAccountOwner) {
      return (
        <React.Fragment>
          <H1 as={HEADING_TYPES.H5}>
            {staticText.getIn(['data', 'inactiveSubscriptionChildTitle'])}
          </H1>
          <p className="cart-access-denied__text">
            {staticText.getIn(['data', 'inactiveSubscriptionChildText'])}
          </p>
        </React.Fragment>
      )
    }

    if (!isAccountOwner) {
      return (
        <React.Fragment>
          <H1 as={HEADING_TYPES.H5}>
            {staticText.getIn(['data', 'activeSubscriptionTitle'])}
          </H1>
          <p className="cart-access-denied__text">
            {staticText.getIn(['data', 'activeSubscriptionChildText'])}
          </p>
        </React.Fragment>
      )
    }

    if (userStatusBlocked) {
      return (
        <React.Fragment>
          <H1 as={HEADING_TYPES.H5}>
            {staticText.getIn(['data', 'blockedTitle'])}
          </H1>
          <p className="cart-access-denied__text">
            {`${staticText.getIn(['data', 'blockedDescription'])}.`}
          </p>
        </React.Fragment>
      )
    }

    if (isAiOnly) {
      return (
        <React.Fragment>
          <H1 as={HEADING_TYPES.H3}>
            {staticText.getIn(['data', 'aiOnlyTitle'])}
          </H1>
          <p className="cart-access-denied__text">
            {`${staticText.getIn(['data', 'aiOnlyText1'])} `}
            <Link to={emailCustomerServiceUrl} target={TARGET_BLANK}>
              {staticText.getIn(['data', 'aiOnlyText2'])}
            </Link>
            {` ${staticText.getIn(['data', 'aiOnlyText3'])}`}
          </p>
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        <H1 as={HEADING_TYPES.H5}>
          {staticText.getIn(['data', 'activeSubscriptionTitle'])}
        </H1>
        <p className="cart-access-denied__text">
          {`${staticText.getIn(['data', 'activeSubscriptionText'])} `}
          <Link to={URL_ACCOUNT}>
            {staticText.getIn(['data', 'activeSubscriptionLink'])}
          </Link>
          {'.'}
        </p>
      </React.Fragment>
    )
  }

  if (!authToken) {
    return null
  }

  return (
    <div className="cart-access-denied">
      {
        userProcessing || authProcessing || userAccountBillingProcessing
          ? <Sherpa className={['cart-access-denied__sherpa']} type={TYPE_SMALL_BLUE} />
          : <React.Fragment>
            {getText()}
            {isAiOnly ? (
              <Button
                url={URL_AI_CHAT}
                type={TYPES.PRIMARY}
                size={SIZES.XSMALL}
                className="cart-access-denied__ai-only-btn"
              >
                <span className="cart-access-denied__ai-only-btn-text">
                  {staticText.getIn(['data', 'aiOnlyCta'])}
                </span>
                <ArrowRightIcon size={20} />
              </Button>
            ) : (
              <Button
                url={URL_HOME}
                type={TYPES.PRIMARY}
                size={SIZES.XSMALL}
                className="cart-access-denied__home-btn"
              >
                {staticText.getIn(['data', 'gaiaHomeLink'])}
              </Button>
            )}
          </React.Fragment>
      }
    </div>
  )
}

CartAccessDeniedPage.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  userAccount: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectStaticText({ storeKey: 'cartAccessDeniedPage' }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      user: state.user,
      userAccount: state.userAccount,
    }),
  ),
)(CartAccessDeniedPage)
